const styles = theme => ({
  loader: {
    // 'padding-top': '32px'
  },
  wrapper: {
    // paddingTop: theme.spacing.unit,
    height: '100vh',
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    flexDirection: 'column'
  },
  logoImage: {
    width: '400px'
  }
})

export default styles
